import { proxy } from 'valtio'
import { devtools, subscribeKey } from 'valtio/utils'
import { getHistory } from '@/api/chat'
import { SessionStatuTypes, SAFTY_TEXT, RoleTypes } from '@/constants'
import { chatAction, chatState, assistantAction, assistantState } from '@/store'
import { message } from 'antd'

export enum ChatType {
  chat = 'chat',
  agent = 'agent',
  aiAgent = 'aiAgent',
}
export interface NewAgentItemProp {
  id?: string
  name: string
  app_id: string | null
  image?: string | null
  avatar?: string | null
  agent_type?: string | null
  url?: string | null
  [key: string]: any
}
export interface SessionsProp {
  sessionId: string | null
  sessionName: string
  createdTime: number | null
  plugins: string | null
  agent_type: string | 'chat' | 'bots' | 'agents'
  agent_url: string | null
  icon_url: string | null
}

export const chatSideBarState = proxy<{
  sessionId: string | null // 对话id
  chatType: ChatType // 对话类型
  isHistory: boolean // 是否是历史
  historySessions: SessionsProp[] // 会话消息列表
  assistantSessions: SessionsProp | null // 暂存的智能体
}>({
  // 当前会话 id
  sessionId: null,
  chatType: ChatType.chat,
  // 会话消息列表
  historySessions: [],
  // 是否是历史会话
  isHistory: false,
  assistantSessions: null,
})
// 风控匹配
subscribeKey(chatState, 'sessionMessages', val => {
  const item = val.find((i: any) => (i?.text || '').includes(SAFTY_TEXT))
  if (item) {
    chatSideBarAction.getHistoryRecord()
  }
})

// 风控匹配
subscribeKey(chatState, 'sessionStatu', val => {
  if (chatState.refreshHistory) {
    chatState.refreshHistory = false
    if (val === SessionStatuTypes.risk) {
      chatSideBarAction.getHistoryRecord()
    } else if (val === SessionStatuTypes.ready) {
      if (
        chatSideBarState.historySessions[0]?.sessionId !== chatState.sessionId
      ) {
        chatSideBarState.sessionId = chatState.sessionId
        chatSideBarAction.getHistoryRecord()
      }
    }
  }
})

export const chatSideBarAction = {
  // 创建会话
  createNewSession: () => {
    console.log('创建会话')
    assistantAction.changeAgent()
    chatSideBarState.chatType = ChatType.chat
    chatAction.createNewSession()
    chatSideBarState.sessionId = chatState.sessionId
  },
  //   获取历史对话
  getHistoryRecord: () => {
    getHistory()
      .then(({ data }) => {
        // const temp = [{ sessionId: '65b8690f141bdc9bf6f8004d', sessionName: '朋友圈文案', app_id: '65b8690f141bdc9bf6f8004d', chat_type: 1 }, { sessionId: 'u1jn4KN3v6BGEnUF', sessionName: '知识库对话流', app_id: 'u1jn4KN3v6BGEnUF', chat_type: 2 }, { sessionId: 'm2Z7sKSiCtGqtDsk', sessionName: '测试简易对话', app_id: 'm2Z7sKSiCtGqtDsk', chat_type: 2 }, ...data.sessions]
        chatSideBarState.historySessions = data.sessions || []
      })
      .catch(err => {
        console.log('err :>> ', err)
      })
  },
  // 切换历史会话
  changeSelectHistory: async (sessions: SessionsProp | null) => {
    if (
      chatState.sessionStatu === SessionStatuTypes.pending ||
      chatState.sessionStatu === SessionStatuTypes.loading
    ) {
      message.warning('对话正在进行中')
      return
    }
    if (
      assistantState.sessionStatu === SessionStatuTypes.pending ||
      assistantState.sessionStatu === SessionStatuTypes.loading
    ) {
      message.warning('对话正在进行中')
      return
    }
    chatSideBarState.isHistory = true
    if (sessions?.agent_type === 'chat') {
      chatSideBarState.sessionId = sessions.sessionId
      chatSideBarState.chatType = ChatType.chat
      sessions?.sessionId && chatAction.getHistorySession(sessions.sessionId)
    } else if (sessions?.agent_type === 'bots') {
      chatSideBarState.sessionId = sessions.sessionId
      chatSideBarState.chatType = ChatType.agent
      assistantState.curSelectAssistant = { app_id: sessions.sessionId }
      assistantAction.changeAgent()
      assistantAction.updateSubmittable(true)
      sessions.sessionId &&
        (await assistantAction.getAssistantDetail(sessions.sessionId))
      sessions.sessionId && assistantAction.getSessions(sessions.sessionId)
    } else if (sessions?.agent_type === 'agents') {
      chatSideBarState.sessionId = sessions.sessionId
      chatSideBarState.chatType = ChatType.aiAgent
    }
  },
  jumpChatResetData: (item: NewAgentItemProp) => {
    // agent_type
    // chat: 对话平台的主对话，这个时候session id含义不变
    // bots: 旧版智能体，这个时候session id为旧版智能体的id
    // agents：新版智能体，这个时候agent_url为新版智能体chatbox地址
    if (item.agent_type === 'agents') {
      // 新智能体
      chatSideBarState.assistantSessions = {
        sessionId: item.app_id,
        sessionName: item.name ?? '',
        agent_type: 'agents',
        agent_url: item.url || '',
        icon_url: item.icon_url,
        createdTime: null,
        plugins: null,
      }
    } else {
      chatSideBarState.assistantSessions = {
        sessionId: item.app_id,
        sessionName: item.name ?? '',
        agent_type: 'bots',
        agent_url: null,
        icon_url: null,
        createdTime: null,
        plugins: null,
      }
    }
    chatSideBarAction.changeSelectHistory(chatSideBarState.assistantSessions)
  },
  // 销毁Sidebar组件时，清空对话记录
  destroySideBar: () => {
    const temp = chatSideBarState.historySessions.find(
      item => item.sessionId === chatSideBarState?.sessionId,
    )
    if (temp !== undefined) {
      if (temp.agent_type !== 'chat') {
        chatSideBarState.historySessions = []
        chatSideBarState.sessionId = null
        chatSideBarState.isHistory = false
        chatSideBarState.chatType = ChatType.chat
        assistantAction.resetSession()
        chatAction.createNewSession()
      }
    } else {
      if (chatSideBarState.assistantSessions != null) {
        if (chatState.sessionId !== chatSideBarState.sessionId) {
          chatSideBarState.historySessions = []
          chatSideBarState.sessionId = null
          chatSideBarState.isHistory = false
          chatSideBarState.chatType = ChatType.chat
          assistantAction.resetSession()
          chatAction.createNewSession()
        }
      }
    }
    chatSideBarState.assistantSessions = null
    chatSideBarAction.getHistoryRecord()
  },
}
